/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import VendorListNavigation from "@components/Vendors/vendorlist-navigation";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
  clientGetAttachedLocationToVendor,
  clientGetLocationMapEmailsToVendor,
  clientVendorEmailMapping,
  getUserEmailList,
} from "@services/vendors.service";
import { getValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";

interface IGroupsProps {}

const VendorsEmail: React.FunctionComponent<IGroupsProps> = (props: any) => {
  let params = useParams();
  let orgParams = useParams();
  const simpleValidator = useRef(new SimpleReactValidator());
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const mainParams = useParams();
  const [usersList, setUsersList] = React.useState<[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [attachedList, setAttachedList] = useState<any[]>([]);
  const [check, setCheck] = useState<boolean>(false);
  const [clientUsersList, setClientUsersList] = React.useState<[]>([]);

  useEffect(() => {
    getList();
    getVendorUserLists();
    getClientUserLists();
  }, [props.permissionAPITriggered]);

  // useEffect(() => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
  //     getVendorUserLists();
  //   }
  // }, [props.permissionAPITriggered]);

  const getList = async () => {
    try {
      setIsLoading(true);
      let payload = {
        is_active: true,
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : 100,
        search_text: params.search_text,
        sort_by: params.sort_by,
      };
      let queryRequest = QueryRequestHelper(payload);
      let locationRes = await clientGetAttachedLocationToVendor(
        params.id,
        queryRequest,
      );
      let emailRes = await clientGetLocationMapEmailsToVendor(
        params.id,
        queryRequest,
      );

      if (locationRes) {
        setIsLoading(false);
        let locations = getValue(locationRes, `data.locactions`, []);
        let updatedLocations = await locations.map((loc: any) => {
          const emails = emailRes.data.find(
            (email: any) => email?.location?.id === loc.id,
          );
          const toEmailStrings = emails?.to_emails || [];
          const ccEmailStrings = emails?.cc_emails || [];
          const accountLeadEmailStrings = emails?.account_lead_emails || [];

          const toEmailOptions = toEmailStrings.map((email: string) => ({
            id: email,
            value: email,
            label: email,
          }));

          const ccEmailOptions = ccEmailStrings.map((email: string) => ({
            id: email,
            value: email,
            label: email,
          }));

          const accountLeadEmailOptions = accountLeadEmailStrings.map(
            (email: string) => ({
              id: email,
              value: email,
              label: email,
            }),
          );
          return {
            ...loc,
            // to_emails: emails?.to_emails || [],
            // cc_emails: emails?.cc_emails || [],
            to_emails: toEmailOptions,
            cc_emails: ccEmailOptions,
            account_lead_emails: accountLeadEmailOptions,
          };
        });
        setAttachedList(updatedLocations);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  const handleSave = async (rowData: any) => {
    // let payload = {
    //   to_emails: rowData.to_emails || [],
    //   cc_emails: rowData.cc_emails || [],
    //   account_lead_emails: rowData.account_lead_emails || [],
    //   vendor_id: mainParams.id,
    //   location_id: rowData.id,
    // };
    let payload = {
      to_emails: (rowData.to_emails || []).map((item: any) =>
        typeof item === "string" ? item : item.value || item.email || item.id,
      ),
      cc_emails: (rowData.cc_emails || []).map((item: any) =>
        typeof item === "string" ? item : item.value || item.email || item.id,
      ),
      account_lead_emails: (rowData.account_lead_emails || []).map(
        (item: any) =>
          typeof item === "string" ? item : item.value || item.email || item.id,
      ),
      vendor_id: mainParams.id,
      location_id: rowData.id,
    };
    try {
      let resp = await clientVendorEmailMapping(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getList();
      }
    } catch (error) {
      throw error;
    }
  };

  const getVendorUserLists = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: 1,
      page_size: 100,
      search_text: params.search_text,
      sort_by: params.sort_by,
      user_type: "VENDOR",
      vendor_id: orgParams.id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getUserEmailList(queryRequest);
      if (resp) {
        setUsersList(
          getValue(resp, `data.users`, []).map((item: object) => {
            return {
              id: getValue(item, `email`, ""),
              value: getValue(item, `email`, ""),
              label: getValue(item, `email`, ""),
            };
          }),
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getClientUserLists = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let user: any = JSON.parse(getValue(localStorage, `user`, ""));
    let payload: any = {
      page_no: 1,
      page_size: 100,
      search_text: params.search_text,
      sort_by: params.sort_by,
      user_type: "CLIENT",
      org_id: getValue(user, `org_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getUserEmailList(queryRequest);
      if (resp) {
        setClientUsersList(
          getValue(resp, `data.users`, []).map((item: object) => {
            return {
              id: getValue(item, `email`, ""),
              value: getValue(item, `email`, ""),
              label: getValue(item, `email`, ""),
            };
          }),
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: () => (
          <div>
            Site <br /> <small className="text-muted">Site ID</small>
          </div>
        ),
        accessor: "location_name",
        width: 150,
        Cell: ({ row }: any) => {
          return (
            <div>
              <div>
                <b>{getValue(row, `original.location_name`, "")}</b>
              </div>
              <div>{getValue(row, `original.location_id`, "")}</div>
            </div>
          );
        },
      },
      {
        Header: "To Emails",
        accessor: "to_emails",
        width: 300,
        Cell: ({ row }: any) => (
          <div className="pl-2">
            <InputField
              inputType="INPUT_REACT_SELECT_MODAL"
              placeholder="Choose To Emails"
              name="to_emails"
              id={`to_emails_${row.original.location_id}`}
              value={row.original.to_emails || []}
              options={usersList}
              onChange={(selected: any) => {
                const updatedData = attachedList.map((d) =>
                  d.location_id === row.original.location_id
                    ? { ...d, to_emails: selected || [] }
                    : d,
                );
                setAttachedList(updatedData);
              }}
              label="To Emails"
              isMulti={true}
              validator={simpleValidator}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
        ),
      },
      {
        Header: "CC Emails",
        accessor: "cc_emails",
        width: 300,
        Cell: ({ row }: any) => (
          <InputField
            inputType="INPUT_REACT_SELECT_MODAL"
            placeholder="Choose cc Emails"
            name="cc_emails"
            id={`cc_emails_${row.original.location_id}`}
            value={row.original.cc_emails || []}
            options={clientUsersList}
            onChange={(selected: any) => {
              const updatedData = attachedList.map((d) =>
                d.location_id === row.original.location_id
                  ? { ...d, cc_emails: selected || [] }
                  : d,
              );
              setAttachedList(updatedData);
            }}
            label="CC Emails"
            isMulti={true}
            validator={simpleValidator}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
          />
        ),
      },
      {
        Header: "Account Lead Emails",
        accessor: "account_lead_emails",
        width: 300,
        Cell: ({ row }: any) => (
          <InputField
            inputType="INPUT_REACT_SELECT_MODAL"
            placeholder="Choose account lead emails"
            name="account_lead_emails"
            id={`account_lead_emails_${row.original.location_id}`}
            value={row.original.account_lead_emails || []}
            options={clientUsersList}
            onChange={(selected: any) => {
              const updatedData = attachedList.map((d) =>
                d.location_id === row.original.location_id
                  ? { ...d, account_lead_emails: selected || [] }
                  : d,
              );
              setAttachedList(updatedData);
            }}
            label="Account Lead Emails"
            isMulti={true}
            validator={simpleValidator}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
          />
        ),
      },
      {
        Header: "Actions",
        width: 150,
        Cell: ({ row }: any) => (
          <button
            className="ascent-button ascent-button--header-buttons ascent-button--secondary my-0"
            onClick={() => handleSave(row.original)}
          >
            Save
          </button>
        ),
      },
    ],
    [attachedList],
  );

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {}),
    ).map((item) => parseInt(item));
    let selectedIds =
      attachedList.length > 0
        ? attachedList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index),
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, "")),
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {};
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {};
    }
    return {};
  };

  return (
    <>
      <Layout>
        <VendorListNavigation id={params.id} parentId={params.parentId} />
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "configuration_vendor",
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <div
              className="map-vendor-wrapper map-vendor-wrapper--vendor w-100 pt-5 mt-5"
              style={{ maxWidth: "892px" }}
            >
              <h5 className="map-vendor__search-title">Assigned Site</h5>
              {isLoading ? (
                <Loader />
              ) : getValue(attachedList, `length`, 0) > 0 ? (
                <>
                  <div className="vendor-location-mapping-table vendor-email-mapping-table w-auto d-inline-block">
                    <ScrollableDataTable
                      columns={columns}
                      data={attachedList}
                      checkboxlogo
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                    />
                  </div>
                </>
              ) : (
                <>
                  {Object.keys(urlParams).length !== 0 ? (
                    <>
                      <Notfound />
                    </>
                  ) : (
                    <Notfound />
                  )}
                </>
              )}
            </div>
          </>
        )}
      </Layout>
    </>
  );
};

export default VendorsEmail;
